export const selectTruck = (truck) => ({
  type: 'SELECT_TRUCK',
  truck
});

export const setTrucks = (trucks) => ({
  type: 'SET_TRUCKS',
  trucks
});
